import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
    selector: 'ramastanfooter',
    template: require('./ramastanfooter.component.html'),
    styles: [require('./ramastanfooter.component.css')],
    encapsulation: ViewEncapsulation.None
})
/** ramastanfooter component*/
export class RamastanFooterComponent {
    /** ramastanfooter ctor */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/ramastanfooter/ramastanfooter.component.ts